<template>
  <Modal
    class="tagsModal newModal"
    v-model="oilbrandPop"
    title="编辑油品品牌"
    width="500px"
    :mask-closable="false"
    :closable="false"
  >
    <div class="tagsWrap">
      <!-- <ul class="curTags">
                <li :class="['seled',{opac:isManager}]" v-for="label in curNewTags" :key="label.id">
                    <span :key="label.id">{{label.value || '--'}}</span>
                    <Icon @click="delSeledTag(label.id)" type="md-close-circle" v-if="!isManager" />
                </li>
            </ul> -->
      <div class="addWrap">
        <!-- <Input v-model="newTag" maxlength="12" show-word-limit placeholder="请输入品牌 (最多12个字)">
                    <Button @click="addNewLabel" slot="append" :disabled="isManager">新增</Button>
                </Input> -->
        <div class="items-width">
          <div
            v-for="(label, index) in oilBrandStoreLists"
            class="flex"
            :key="index"
          >
            <Input
              v-model="label.value"
              :key="index"
              maxlength="12"
              placeholder="请输入油品品牌 (最多12个字)"
            >
              <!-- <Button @click="addNewLabel" slot="append" :disabled="isManager">新增</Button> -->
            </Input>
            <div @click="remove(label.id)" class="append">删除</div>
          </div>
          <div class="imgadda" @click="addinputd">
            <img
              src="../../../assets/images/add.png"
              style="width: 12px; height: 12px"
            />
            <div class="addinput">新增</div>
          </div>
        </div>
      </div>

      <!-- <div class="tagsManage">
                <h4>油品品牌库</h4>
                <p class="manage" v-if="isManager">
                    <span @click="delStoreLabels" class="error" style="cursor:pointer">删除</span>
                    &nbsp;&nbsp;&nbsp;
                    <span @click="managerLabels('finish')" class="going" style="cursor:pointer">完成</span>
                </p>
                <p class="manage" style="cursor:pointer" @click="managerLabels('start')" v-else>
                    <Icon type="md-settings" />
                    管理
                </p>
            </div>
            <div class="storeWrap" v-if="!isManager">
                <ul class="curTags">
                    <li :class="[{seled: label.checked === true}]" @click="selStoreTag(label)"  v-for="label in oilBrandStoreLists" :key="label.id" style="cursor: pointer;">
                        <span>{{label.value}}</span>
                    </li>
                </ul>
                <Spin fix v-if="!oilBrandStoreLists.length"></Spin>
            </div>
            <div class="storeWrap" v-else>
                <CheckboxGroup size="small" v-model="selTags">
                    <ul class="curTags">
                        <li :class="[{seled: label.checked === true}]" v-for="label in oilBrandStoreLists" :key="label.id">
                            <Checkbox :label="label.id">
                                <span>{{label.value}}</span>
                            </Checkbox>
                        </li>
                    </ul>
                </CheckboxGroup>
            </div> -->
    </div>

    <div slot="footer">
      <Button @click="okPop" type="primary">提交</Button>
      <Button @click="cancelPop">取消</Button>&nbsp;
    </div>
    <Spin size="large" fix v-if="wrapLoading"></Spin>
  </Modal>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
export default {
  props: {
    oilbrandPop: Boolean,
    closePop: Function,
    setBrandId: Function,
    refreshOilBrand: Function,
  },
  watch: {
    oilbrandPop() {
      this.$nextTick(() => {
      
          var modal = document.getElementsByClassName("items-width");
          console.log(modal[0]);
          modal[0].scrollTop = 0;
       ;

        //
      });
    },
  },
  data() {
    return {
      newTag: "", //新增品牌
      curNewTags: [], //当前选中的品牌组
      selTags: "", //选择的删除品牌
      isManager: false, //管理品牌
      oilBrandStoreLists: [], //品牌库集合
      wrapLoading: false,
      btnLoading: false,
    };
  },
  created() {
    this.getLabels();
  },
  mounted() {},
  methods: {
    addinputd() {
      // let len = this.oilBrandStoreLists.length;
      // let oilBrandStoreLists = this.oilBrandStoreLists;

      // let value = oilBrandStoreLists[len - 1]["value"];

      // if (value == "") return this.$Message.info("请填写油品名");
      // this.wrapLoading = true;

      //     size: 200,
      //     type: "brand",
      //     gangedValueMap: {
      //         tenantId: this.curSeledTenantId,
      //     },
      //     value: value,
      // }).then((res) => {
      //     if (res.code === "00000") {
      //         this.newTag = "";
      //         this.getLabels();
      //         this.refreshOilBrand();
      //         // this.refreshWorkshop()
      //         // this.$store.dispatch('listCollection', 'workShop')
      //     }
      //     this.wrapLoading = false;
      // });
      this.oilBrandStoreLists.push({
        value: "",
        id: "",
      });
    },
    okPop() {
      let finalList = [];
    
      this.oilBrandStoreLists.forEach((item) => {
        if (item.value) {
          finalList.push({
            type: "brand",
            value: item.value,
            id: item.id,
          });
        }
      });
      api.axss("post", "/ocm-admin/dict/add", finalList).then((res) => {
        if (res.code === "00000") {
          this.newTag = "";
          this.getLabels();
          this.refreshOilBrand();
          this.cancelPop();
          this.$Message.success("提交成功");
          // this.refreshWorkshop()
          // this.$store.dispatch('listCollection', 'workShop')
        }
      });
    },
    remove(id) {
      if (id) {
        this.selTags = id;
        this.$nextTick(() => {
          this.delStoreLabels();
        });
      } else this.oilBrandStoreLists.pop();
    },
    getLabels() {
      api
        .axss("post", "/ocm-admin/dict/page", {
          type: "brand",
          size: 99,
        })
        .then((res) => {
          if (res.code === "00000") {
            let lists = res.data.records;
            // lists.forEach((item, index) => {
            //     this.curNewTags.forEach((ite) => {
            //         if (item.id === ite.id) lists.splice(index, 1); // lists[index].checked = true
            //     });
            // });
            // lists.push({
            //     value: "",
            //     id: "",
            // });
            this.oilBrandStoreLists = lists;
          }
        });
    },
    // addNewLabel() {
    //     if (!this.newTag) return this.$Message.info("请填写品牌名");
    //     this.wrapLoading = true;
    //     api.axss("post", "/ocm-admin/dict/add", {
    //         type: "brand",
    //         value: this.newTag,
    //     }).then((res) => {
    //         if (res.code === "00000") {
    //             this.newTag = "";
    //             this.getLabels();
    //             this.refreshOilBrand();
    //         }
    //         this.wrapLoading = false;
    //     });
    // },
    delStoreLabels() {
      // if (!this.selTags.length)
      //     return this.$Message.info("请至少选择一个品牌");
      this.wrapLoading = true;
      api
        .axss("get", "/ocm-admin/dict/delOilBrand", {}, { id: this.selTags })
        .then((res) => {
          if (res.code === "00000") {
            // this.selTags = [];
            this.getLabels();
            this.refreshOilBrand();
          } else {
            this.$Message.error(res.msg);
          }
          this.wrapLoading = false;
        });
    },
    // managerLabels(tag) {
    //     this.selTags = [];
    //     if (tag === "start") this.isManager = true;
    //     else if (tag === "finish") this.isManager = false;
    // },
    // selStoreTag(curItem) {
    //     //绑定新品牌
    //     //更新当前品牌组
    //     const curTag = {
    //         id: curItem.id,
    //         value: curItem.value,
    //     };

    //     // 还原已选标签
    //     if (this.curNewTags.length)
    //         this.oilBrandStoreLists.push(this.curNewTags[0]);
    //     this.curNewTags = [curTag];

    //     //去除品牌池中的id
    //     this.oilBrandStoreLists.forEach((item, index) => {
    //         if (item.id === curItem.id) {
    //             this.oilBrandStoreLists.splice(index, 1);
    //             // this.oilBrandStoreLists[index].checked = true
    //         }
    //     });
    // },
    // delSeledTag(id) {
    //     //删除选中品牌组
    //     this.curNewTags.forEach((item, index) => {
    //         if (+item.id === +id) this.curNewTags.splice(index, 1);
    //     });
    //     this.getLabels();
    // },
    // surePop() {
    //     if (this.curNewTags.length === 0) {
    //         return this.$Message.info("请选择油品品牌");
    //     } else {
    //         this.$emit("setBrandId", this.curNewTags[0].id);
    //         this.cancelPop();
    //     }
    // },
    cancelPop() {
      this.closePop();
      this.curNewTags = [];
    },
  },
};
</script>

<style lang='less'>
.tagsModal {
  .tagsWrap {
    position: relative;

    .curTags {
      display: flex;
      flex-wrap: wrap;

      li {
        position: relative;
        font-size: 12px;
        color: #444;
        background: #f2f2f2;
        border-radius: 10px;
        padding: 2px 8px;
        margin-right: 14px;
        margin-bottom: 10px;

        span {
          font-size: 12px;
        }

        .ivu-icon {
          position: absolute;
          top: -8px;
          right: -5px;
          font-size: 16px;
          color: #aaa;
          cursor: pointer;
        }

        &.seled {
          color: #0c479d;
          background: #d0e5f7;
        }

        &.opac {
          opacity: 0.4;
        }
      }
    }

    .addWrap {
      margin: 10px 0;

      .ivu-input-wrapper {
        .ivu-input-word-count {
          color: #ccc;
          right: 66px;
          z-index: 3;
        }
      }

      .ivu-input-group-append {
        .ivu-btn {
          box-shadow: none;
        }
      }
    }

    .tagsManage {
      display: flex;
      margin: 20px 0 10px;

      h4 {
        font-size: 14px;
      }

      .manage {
        margin-left: auto;
        font-size: 14px;

        .ivu-icon {
          font-size: 16px;
        }
      }
    }

    .storeWrap {
      position: relative;
      border: 1px solid #dcdee2;
      border-radius: 6px;
      padding: 10px 8px 0;
      min-width: 44px;
      height: 118px;
      // max-height: 118px;
      overflow-y: auto;
    }
  }
}

.items-width {
  height: 300px;
  overflow: auto;
}

.flex {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .append {
    width: 28px;
    margin-left: 12px;
    text-align: right;
    color: #0c479d;
    cursor: pointer;
    margin-top: 0px;
    font-size: 12px;
  }
}

.imgadda {
  display: flex;
  font-size: 12px;

  font-weight: 400;
  color: #0070cc;
  line-height: 8px;
  margin-top: 21px;
  align-items: center;
  div {
    margin-left: 3px;
    cursor: pointer;
  }
}
</style>